import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { BannerItem } from "./BannerItem";
import { SimilarSitesWrapper, VersusWrapper } from "./StyledComponents";

export interface IBannerSitesProps {
    domains: string[];
    icons: Record<string, string>;
}

export const BannerSites = ({ domains, icons }: IBannerSitesProps) => {
    const translate = useTranslation();
    const [mainDomain, ...comparisonDomains] = domains;

    return (
        <SimilarSitesWrapper>
            <BannerItem
                domain={mainDomain}
                imgSrc={icons[mainDomain]}
                data-automation="ranking-distribution-compare-banner-main-site"
            />
            <VersusWrapper data-automation="ranking-distribution-compare-banner-versus">
                {translate("compare.banner.vs.text.default")}
            </VersusWrapper>
            {comparisonDomains.map((website) => (
                <BannerItem
                    key={website}
                    domain={website}
                    imgSrc={icons[website]}
                    data-automation="ranking-distribution-compare-banner-similar-site"
                />
            ))}
        </SimilarSitesWrapper>
    );
};
